import * as NaturalMulZeroOneTask from "./podtemat2_mnozenie_types/NaturalMulZeroOneTask";
import * as NaturalMulTableTask from "./podtemat2_mnozenie_types/NaturalMulTableTask";
import * as NaturalMulTwoDigitByOneDigitTask from "./podtemat2_mnozenie_types/NaturalMulTwoDigitByOneDigitTask";
import * as NaturalMulTwoDigitByFullTensTask from "./podtemat2_mnozenie_types/NaturalMulTwoDigitByFullTensTask";
import * as NaturalMulTwoDigitByPowerOfTenMultipleTask from "./podtemat2_mnozenie_types/NaturalMulTwoDigitByPowerOfTenMultipleTask";
import * as NaturalMulTwoDigitByTwoDigitTask from "./podtemat2_mnozenie_types/NaturalMulTwoDigitByTwoDigitTask";
import * as NaturalMulTwoDigitByTwoDigitWithZerosTask from "./podtemat2_mnozenie_types/NaturalMulTwoDigitByTwoDigitWithZerosTask";

export const registry = {
  NaturalMulZeroOneTask,
  NaturalMulTableTask,
  NaturalMulTwoDigitByOneDigitTask,
  NaturalMulTwoDigitByFullTensTask,
  NaturalMulTwoDigitByPowerOfTenMultipleTask,
  NaturalMulTwoDigitByTwoDigitTask,
  NaturalMulTwoDigitByTwoDigitWithZerosTask,
};

export function generateTasks() {
  return [
    NaturalMulZeroOneTask.generateTask(),
    NaturalMulTableTask.generateTask(),
    NaturalMulTwoDigitByOneDigitTask.generateTask(),
    NaturalMulTwoDigitByFullTensTask.generateTask(),
    NaturalMulTwoDigitByTwoDigitTask.generateTask(),
    NaturalMulTwoDigitByPowerOfTenMultipleTask.generateTask(),
    NaturalMulTwoDigitByTwoDigitWithZerosTask.generateTask(),
  ];
}

export function renderTask(task) {
  const m = registry[task.type];
  return m ? m.renderTask(task) : null;
}

export function renderInput(task, userAnswer, onChange, disabled) {
  const m = registry[task.type];
  return m ? m.renderInput(task, userAnswer, onChange, disabled) : null;
}

export function checkAnswer(task, userAnswer) {
  const m = registry[task.type];
  return m ? m.checkAnswer(task, userAnswer) : false;
}

export function renderAnswer(task) {
  const m = registry[task.type];
  return m ? m.renderAnswer(task) : null;
}

export function renderExplanation(task) {
  const m = registry[task.type];
  return m ? m.renderExplanation(task) : null;
}

export function renderUserAnswer(task, userAnswer) {
  const m = registry[task.type];
  return m && m.renderUserAnswer ? m.renderUserAnswer(userAnswer) : null;
}

const naturalMultiplicationSubtopic = {
  registry,
  generateTasks,
  renderTask,
  renderInput,
  checkAnswer,
  renderAnswer,
  renderExplanation,
  renderUserAnswer,
};

export default naturalMultiplicationSubtopic;
